module.exports = __webpack_public_path__ + "img/5.b9a33fb6.png";